import React, { useState } from "react";
import { useSelector } from "react-redux";
import Loader from "../../Loader";
import SingleServiceFlip from "../../components/Service/SingleServiceFlip";
import { decodeAndStripHtml } from "../util";
import { S3_BASE_URL } from "../../../../Service";

const ServiceOneMain = () => {
  const [services, setServices] = useState(
    useSelector((state) => state.data).service
  );
  const [loadingServices, setLoadingServices] = useState(false);

  return (
    <React.Fragment>
      {/* services-area-start */}
      <div className="rs-services style2 pt-120 pb-120 md-pt-80 md-pb-80">
        <div className="container">
          <div className="row">
            {loadingServices ? (
              <Loader />
            ) : Array.isArray(services) && services.length > 0 ? (
              services.map((service) => (
                <div key={service._id} className="col-lg-4 col-md-6 mb-26">
                  <SingleServiceFlip
                    itemClass="flip-box-inner"
                    serviceImage={`${S3_BASE_URL}/${service.serviceImage}`}
                    serviceURL={`/service/${service._id}`}
                    Title={service.title}
                    TextDesc={decodeAndStripHtml(service.shortDescription)}
                    // TextDesc={decodeHtml(service.shortDescription)}
                    ButtonClass="readon view-more"
                    ButtonText="Get In Touch"
                  />
                </div>
              ))
            ) : (
              <p>No services available at the moment.</p>
            )}
          </div>
        </div>
      </div>
      {/* services-area-end */}

      {/* process-area-start */}
      {/* <div className="rs-process style5 bg5 pt-120 pb-120 md-pt-80 md-pb-64">
        {htmlContent2 ? (
          <div dangerouslySetInnerHTML={{ __html: htmlContent2 }} />
        ) : (
          ""
        )}
      </div> */}

      {/* Contact Form */}

      {/* newsletter-area-start */}
      {/* <div className="newsletter-area">
        {htmlContent3 ? (
          <div dangerouslySetInnerHTML={{ __html: htmlContent3 }} />
        ) : (
          ""
        )}
      </div> */}
    </React.Fragment>
  );
};

export default ServiceOneMain;
